(function(){
  var d=document.documentElement, root=document.querySelector('.lp');
  var mq=matchMedia('(prefers-reduced-motion: reduce)'), minH=+root.getAttribute('data-lp-minh')||700;
  var LP=window.LP={rm:mq.matches,static:false};
  var lastW=innerWidth, lastH=d.clientHeight;
  function mode(force){
    var h=d.clientHeight, w=innerWidth;
    // URL-bar jitter changes height only; re-evaluate on width/orientation or a big height change
    if(!force && w===lastW && Math.abs(h-lastH)<160) return;
    lastW=w; lastH=h;
    var s=LP.rm||h<minH;
    if(s!==LP.static||force){LP.static=s; d.classList.toggle('lpStatic',s); dispatchEvent(new CustomEvent('lp:mode',{detail:{static:s}}));}
  }
  LP.rm=mq.matches; mode(true);
  mq.addEventListener&&mq.addEventListener('change',function(e){LP.rm=e.matches;mode(true);});
  addEventListener('resize',function(){mode(false);});

  // reveals
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}
  });},{rootMargin:'0px 0px -10% 0px'}):null;
  LP.reveal=function(scope){(scope||root).querySelectorAll('.lpRv,.lpWipe,.lpHead,[data-lp-stagger],[data-lp-in]').forEach(function(el){
    if(el.classList.contains('is-in')) return; io?io.observe(el):el.classList.add('is-in');});};
  LP.reveal();
  // Tab can park a target inside the observer's bottom dead zone: reveal its ancestors on focus (Men's session 17/09)
  root.addEventListener('focusin',function(e){var el=e.target;
    while(el&&el!==root){if(el.matches('.lpRv,.lpWipe,.lpHead,[data-lp-stagger],[data-lp-in]')) el.classList.add('is-in'); el=el.parentElement;}});

  // scrub: progress of a sticky runway container, rAF-throttled, static-gated
  var subs=[], tick=false;
  function run(){tick=false; if(LP.static) return; var vh=innerHeight;
    subs.forEach(function(s){var r=s.el.getBoundingClientRect(), span=s.span?s.span(s.el):(r.height-vh);
      var p=span>0?Math.min(1,Math.max(0,-r.top/span)):(r.top<=0?1:0);
      if(p!==s.p){s.p=p;s.fn(p,s.el);}});}
  LP.scrub=function(el,fn,span){subs.push({el:el,fn:fn,span:span});req();};
  function req(){if(!tick){tick=true;requestAnimationFrame(run);}}
  LP.update=function(){subs.forEach(function(s){s.p=undefined;});req();};
  addEventListener('scroll',req,{passive:true}); addEventListener('resize',req); addEventListener('lp:mode',LP.update);

  // toast + tile actions (prototype echoes, as the homepage)
  var toast=root.querySelector('.lpToast'), tt=null;
  LP.say=function(msg){toast.textContent=msg;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on');},2600);};
  root.addEventListener('click',function(e){
    var b=e.target.closest('.lpTile button[data-act]'); if(!b) return;
    var nm=b.getAttribute('data-nm'), act=b.getAttribute('data-act');
    if(act==='wish'){var on=b.getAttribute('aria-pressed')!=='true';
      b.setAttribute('aria-pressed',String(on)); b.classList.toggle('is-on',on);
      b.setAttribute('aria-label',(on?'Remove ':'Add ')+nm+(on?' from wishlist':' to wishlist'));
      LP.say((on?'Added to wishlist':'Removed from wishlist')+' — '+nm+'.');}
    else if(act==='cart') LP.say('Added to cart — '+nm+'.');
    else LP.say('Finding pieces similar to '+nm+'.');
  });

  // in-page anchors own their scroll (Powermark 15/09: native smooth anchor scroll can be abandoned)
  LP.go=function(t,top){
    if(typeof t==='string') t=document.getElementById(t); if(!t) return;
    var m=parseFloat(getComputedStyle(t).scrollMarginTop)||0;
    var y=top!=null?top:Math.round(t.getBoundingClientRect().top+scrollY-m);
    scrollTo({top:Math.max(0,y),behavior:LP.rm?'auto':'smooth'});
    try{history.replaceState(null,'','#'+t.id);}catch(_){}
    if(!t.hasAttribute('tabindex')) t.setAttribute('tabindex','-1');
    try{t.focus({preventScroll:true});}catch(_){}
  };
  root.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function(a){
    a.addEventListener('click',function(e){var t=document.getElementById(a.getAttribute('href').slice(1)); if(!t) return;
      e.preventDefault(); var f=t.getAttribute('data-lp-go'); LP.go(t,f&&window[f]?window[f]():null);});
  });

  // guide reader: tabs ≥901 (single open), accordion ≤900 (independent)
  root.querySelectorAll('[data-lp-guide]').forEach(function(g){
    var bs=[].slice.call(g.querySelectorAll('.lpGuide__b')), wide=matchMedia('(min-width:901px)');
    function set(b,on){b.setAttribute('aria-expanded',String(on)); document.getElementById(b.getAttribute('aria-controls')).hidden=!on;}
    bs.forEach(function(b){b.addEventListener('click',function(){
      var on=b.getAttribute('aria-expanded')!=='true';
      if(wide.matches){ if(!on) return; bs.forEach(function(x){set(x,x===b);}); }
      else set(b,on);
    });});
    function norm(){ if(!wide.matches) return; var open=bs.filter(function(b){return b.getAttribute('aria-expanded')==='true';});
      var keep=open[0]||bs[0]; bs.forEach(function(x){set(x,x===keep);}); }
    wide.addEventListener&&wide.addEventListener('change',norm); norm();
  });

  // rails: arrows gate with aria-disabled (focus kept), diamond dots follow the scroll
  root.querySelectorAll('[data-lp-rail]').forEach(function(r){
    var tr=r.querySelector('.lpRail__track'), prev=r.querySelector('.lpArr--prev'), next=r.querySelector('.lpArr:not(.lpArr--prev)');
    var dots=[].slice.call(r.querySelectorAll('.lpDots button')), items=[].slice.call(tr.children);
    function step(){var a=items[0], b=items[1]; return a&&b?b.offsetLeft-a.offsetLeft:tr.clientWidth;}
    function sync(){var max=tr.scrollWidth-tr.clientWidth-2, x=tr.scrollLeft;
      if(prev) prev.setAttribute('aria-disabled',String(x<=2)); if(next) next.setAttribute('aria-disabled',String(x>=max));
      var i=Math.round(x/step()); if(x>=max) i=items.length-1;
      dots.forEach(function(dt,k){if(k===i) dt.setAttribute('aria-current','true'); else dt.removeAttribute('aria-current');});}
    function go(dir){tr.scrollBy({left:dir*step(),behavior:LP.rm?'auto':'smooth'});}
    prev&&prev.addEventListener('click',function(){go(-1);}); next&&next.addEventListener('click',function(){go(1);});
    dots.forEach(function(dt,k){dt.addEventListener('click',function(){tr.scrollTo({left:k*step(),behavior:LP.rm?'auto':'smooth'});});});
    tr.addEventListener('scroll',function(){requestAnimationFrame(sync);},{passive:true}); addEventListener('resize',sync); sync();
  });

  // sticky CTA: off over [data-lp-hero] and once the footer arrives; phones step aside on scroll-down
  var st=root.querySelector('[data-lp-sticky]');
  if(st){
    var heroes=[].slice.call(root.querySelectorAll('[data-lp-hero]')), offs=[].slice.call(root.querySelectorAll('[data-lp-sticky-off]')), main=document.getElementById('MainContent'), lastY=scrollY, down=false, t2=false;
    function upd(){t2=false; var y=scrollY, vh=innerHeight;
      if(innerWidth>900) down=false; else if(y>lastY+6) down=true; else if(y<lastY-6) down=false;
      if(Math.abs(y-lastY)>6) lastY=y;
      var past=heroes.every(function(h){return h.getBoundingClientRect().bottom<vh*.35;});
      var clear=offs.every(function(o){var r=o.getBoundingClientRect(); return r.bottom<vh*.1||r.top>vh*.9;});
      st.classList.toggle('is-on', past && clear && main.getBoundingClientRect().bottom>vh-8 && !down);}
    addEventListener('scroll',function(){if(!t2){t2=true;requestAnimationFrame(upd);}},{passive:true}); addEventListener('resize',upd); upd();
  }
})();


(function(){
  document.querySelector('.mnHero').classList.add('is-go');

  // manifesto: word i lights up between 86% and 66% of the viewport (staggered along the line)
  (function(){
    var ws=[].slice.call(document.querySelectorAll('.mnMan__w'));
    var t=false;
    function go(){t=false; if(LP.static){ws.forEach(function(w){w.style.removeProperty('--o');});return;}
      var vh=innerHeight;ws.forEach(function(w,i){
      var r=w.getBoundingClientRect(), c=r.top+r.height/2, start=vh*(.86-i*.035), end=start-vh*.2;
      w.style.setProperty('--o',(.16+.84*Math.min(1,Math.max(0,(start-c)/(start-end)))).toFixed(3));});}
    function req(){if(!t){t=true;requestAnimationFrame(go);}}
    addEventListener('scroll',req,{passive:true}); addEventListener('resize',req); addEventListener('lp:mode',req); go();
  })();

  // category stage
  (function(){
    var root=document.getElementById('shop'); if(!root) return;
    var tabs=[].slice.call(root.querySelectorAll('.mnCat__tab')), bar=root.querySelector('.mnCat__bar'), tl=root.querySelector('.mnCat__tabs');
    var pics=root.querySelectorAll('.mnCat__pic'), panels=root.querySelectorAll('.mnCat__panel'), stage=root.querySelector('.mnCat__stage');
    var cur=0, tm=null;
    function place(){var t=tabs[cur];bar.style.setProperty('--bx',t.offsetLeft+'px');bar.style.setProperty('--bw',t.offsetWidth+'px');}
    function dots(p){var rail=p.querySelector('.mnCat__rail'), ds=p.querySelectorAll('.mnDots i');
      if(!ds.length||getComputedStyle(rail).display!=='flex') return;
      var rr=rail.getBoundingClientRect(), pad=parseFloat(getComputedStyle(rail).paddingLeft)||0;
      [].forEach.call(rail.children,function(li,i){var r=li.getBoundingClientRect(), c=r.left+r.width/2;   // a dot is on when its tile's centre is in the view
        ds[i].classList.toggle('is-on',c>rr.left+pad&&c<rr.right-pad);});}
    [].forEach.call(panels,function(p){[].forEach.call(p.querySelectorAll('.mnCat__rail>li'),function(li,i){li.style.setProperty('--i',i);});
      p.querySelector('.mnCat__rail').addEventListener('scroll',function(){dots(p);},{passive:true}); dots(p);});
    function show(i,focus){
      if(i===cur){if(focus) tabs[i].focus(); return;}
      var dir=i>cur?1:-1, old=cur; cur=i;
      tabs.forEach(function(t,j){t.setAttribute('aria-selected',String(j===i));t.tabIndex=j===i?0:-1;});
      if(focus) tabs[i].focus({preventScroll:true});
      var t=tabs[i];
      if(t.offsetLeft<tl.scrollLeft||t.offsetLeft+t.offsetWidth>tl.scrollLeft+tl.clientWidth) tl.scrollTo({left:t.offsetLeft-24,behavior:LP.rm?'auto':'smooth'});
      place();
      [].forEach.call(pics,function(p,j){p.classList.remove('is-off');
        if(j===old){p.classList.add('is-off');p.classList.remove('is-on');} else if(j!==i) p.classList.remove('is-on');});
      var np=pics[i]; np.classList.toggle('is-from-l',dir<0); np.getBoundingClientRect(); np.classList.add('is-on');
      clearTimeout(tm); tm=setTimeout(function(){pics[old].classList.remove('is-off');},LP.rm?0:950);
      var p=panels[i];
      [].forEach.call(panels,function(q,j){if(j!==i){q.hidden=true;q.classList.remove('is-on','is-deal','is-dealt');}});
      p.style.setProperty('--dir',dir); p.classList.remove('is-dealt'); p.classList.add('is-deal','is-on'); p.hidden=false;
      var rail=p.querySelector('.mnCat__rail'); rail.scrollLeft=0; dots(p);
      p.getBoundingClientRect(); requestAnimationFrame(function(){p.classList.add('is-dealt');p.classList.remove('is-deal');});
      try{history.replaceState(null,'','#shop-'+t.getAttribute('data-k'));}catch(_){}
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){show(i,false);});
      t.addEventListener('keydown',function(e){var k=e.key, n=tabs.length, j=null;
        if(k==='ArrowRight') j=(i+1)%n; else if(k==='ArrowLeft') j=(i-1+n)%n; else if(k==='Home') j=0; else if(k==='End') j=n-1;
        if(j!==null){e.preventDefault();show(j,true);}});
    });
    var sx=null, sy=0;   // swipe on the photo
    stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    stage.addEventListener('touchend',function(e){if(sx===null) return;var dx=e.changedTouches[0].clientX-sx, dy=e.changedTouches[0].clientY-sy; sx=null;
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4) show(Math.min(tabs.length-1,Math.max(0,cur+(dx<0?1:-1))),false);},{passive:true});
    addEventListener('resize',function(){place();dots(panels[cur]);}); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(place); place();
    // deep links #shop-<key> (guide + gifting links, shared URLs): pick the tab, land on the stage, focus the tab
    function fromHash(scroll){var m=/^#shop-(\w+)$/.exec(location.hash); if(!m) return false;
      var j=tabs.findIndex(function(t){return t.getAttribute('data-k')===m[1];}); if(j<0) return false;
      show(j,false); if(scroll){LP.go(root); try{history.replaceState(null,'','#shop-'+m[1]);}catch(_){} tabs[j].focus({preventScroll:true});}
      return true;}
    document.addEventListener('click',function(e){var a=e.target.closest('a[href^="#shop-"]'); if(!a) return; e.preventDefault();
      try{history.pushState(null,'',a.getAttribute('href'));}catch(_){} fromHash(true);});
    addEventListener('hashchange',function(){fromHash(true);});
    if(location.hash) setTimeout(function(){fromHash(true);},60);
  })();

  // shop the look — the homepage initWS() mechanics: the cell nearest the centre becomes the
  // lead (scale by distance, smoothstep), the buy rows fade with it, the dots follow, and the
  // rail drags. Static mode keeps a plain snap rail (CSS owns the sizing there).
(function(){

  var LP = window.LP || {};

  var sec = document.getElementById('look');


  if(!sec){
    console.error('[INIT] #look NOT FOUND');
    return;
  }


  var tr = document.getElementById('mnWsTrack');

  if(!tr){
    console.error('[INIT] #mnWsTrack NOT FOUND');
    return;
  }


  var cells = [].slice.call(
    tr.querySelectorAll('.mnCell')
  );

  var dots = [].slice.call(
    sec.querySelectorAll('.mnWs__ind button')
  );

  var vids = [].slice.call(
    tr.querySelectorAll('video')
  );

  var snds = [].slice.call(
    tr.querySelectorAll('.mnSnd')
  );


  /* ---------------------------------------
     LOG EVERY VIDEO
  --------------------------------------- */

  vids.forEach(function(v, i){


    v.addEventListener('error', function(){

      console.error(
        '[VIDEO ' + i + '] ERROR',
        v.error
      );

    });

  });


  /* ---------------------------------------
     VARIABLES
  --------------------------------------- */

  var BASE = 0;
  var LEAD = 1.25;
  var REACH = 0;
  var FLOOR = 0;
  var lead = -1;
  var seen = false;
  var ticking = false;


  /* ---------------------------------------
     SOUND BUTTON POINTER FIX
  --------------------------------------- */

  vids.forEach(function(v){

    v.style.pointerEvents = 'none';

  });


  snds.forEach(function(b, i){


    if(!b.style.position){
      b.style.position = 'relative';
    }

  });


  /* ---------------------------------------
     MEASURE
  --------------------------------------- */

  function measure(){

    var wide =
      matchMedia('(min-width:1160px)').matches;

    LEAD =
      wide ? 1.25 : 1.16;

    var gap =
      wide
        ? Math.max(
            24,
            Math.min(
              44,
              tr.clientWidth * 0.024
            )
          )
        : 14;

    tr.style.gap =
      gap.toFixed(0) + 'px';


    if(wide){

      var perView = 5;

      var cellW =
        (
          tr.clientWidth -
          (perView - 1) * gap
        ) / perView;

      var widthBASE =
        cellW * 16 / 9;

      var cs =
        getComputedStyle(sec);

      var padY =
        parseFloat(cs.paddingTop) +
        parseFloat(cs.paddingBottom);

      BASE = widthBASE;


      var avail =
        innerHeight -
        70 -
        chrome();


      if(BASE * LEAD > avail){

        BASE =
          Math.max(
            150,
            avail / LEAD
          );

      }


      var availClip =
        innerHeight -
        70 -
        (chrome() - padY);

      BASE = widthBASE;


      if(BASE * LEAD > availClip){

        BASE =
          Math.max(
            150,
            availClip / LEAD
          );

      }


      BASE *= 1.15;

      FLOOR = BASE;

    }else{

      var peek =
        tr.clientWidth * 0.05;

      var leadW =
        Math.max(
          120,
          tr.clientWidth -
          2 * gap -
          2 * peek
        );

      BASE =
        leadW * 16 / 9 / LEAD;

      var capH =
        innerHeight - 100;


      if(BASE * LEAD > capH){

        BASE =
          Math.max(
            150,
            capH / LEAD
          );

      }

      FLOOR = BASE;

    }


    REACH =
      Math.max(
        tr.clientWidth * 0.42,
        BASE * 0.9
      );

  }


  /* ---------------------------------------
     CHROME
  --------------------------------------- */

  function chrome(){

    var head =
      sec.querySelector('.mnWs__head');

    var ind =
      sec.querySelector('.mnWs__ind');

    var buy =
      tr.querySelector('.mnBuy');

    var cs =
      getComputedStyle(sec);


    return (
      (
        head
          ? head.getBoundingClientRect().height +
            parseFloat(
              getComputedStyle(head).marginBottom
            )
          : 0
      )

      +

      (
        buy
          ? buy.getBoundingClientRect().height + 12
          : 70
      )

      +

      (
        ind
          ? ind.getBoundingClientRect().height +
            parseFloat(
              getComputedStyle(ind).marginTop
            )
          : 40
      )

      +

      parseFloat(cs.paddingTop)

      +

      parseFloat(cs.paddingBottom)

      +

      8
    );

  }


  /* ---------------------------------------
     MARK MID
  --------------------------------------- */

  function markMid(){

    if(LP.static){

      return;
    }


    if(!BASE){


      measure();

    }


    var mid =
      tr.getBoundingClientRect().left +
      tr.clientWidth / 2;

    var best = 0;
    var bd = 1e9;


    cells.forEach(function(c, i){

      var r =
        c.getBoundingClientRect();

      var d =
        Math.abs(
          r.left +
          r.width / 2 -
          mid
        );


      if(d < bd){

        bd = d;
        best = i;

      }


      var t =
        Math.max(
          0,
          1 - d / REACH
        );

      var f =
        t * t * (3 - 2 * t);

      var h =
        BASE *
        (
          1 +
          (LEAD - 1) * f
        );


      var m =
        c.querySelector('.mnCell__m');

      var buy =
        c.querySelector('.mnBuy');


      if(m){

        m.style.height =
          h.toFixed(1) + 'px';

        m.style.width =
          (h * 9 / 16).toFixed(1) + 'px';

      }


      c.style.width =
        (h * 9 / 16).toFixed(1) + 'px';


      if(buy){

        buy.style.opacity =
          (
            0.55 +
            0.45 * f
          ).toFixed(3);

      }

    });


    cells.forEach(function(c, i){

      c.classList.toggle(
        'is-lead',
        i === best
      );


      if(i === best){

        c.setAttribute(
          'aria-current',
          'true'
        );

      }else{

        c.removeAttribute(
          'aria-current'
        );

      }

    });


    dots.forEach(function(d, i){

      if(i === best){

        d.setAttribute(
          'aria-current',
          'true'
        );

      }else{

        d.removeAttribute(
          'aria-current'
        );

      }

    });


    if(best !== lead){

      lead = best;

      play(best);

    }

  }


  /* ---------------------------------------
     AUTOPLAY VIDEO
  --------------------------------------- */
  function play(i){
    var leadCell = cells[i];

    vids.forEach(function(v, j){
      var cell = v.closest('.mnCell');

      if(cell !== leadCell){
        if(!v.paused){
          v.pause();
        }

        v.muted = true;

        var btn = cell
          ? cell.querySelector('.mnSnd')
          : null;

        if(btn){
          btn.dataset.on = '0';
          btn.setAttribute(
            'aria-label',
            'Play this film with sound'
          );
        }


        return;
      }

      /*
      * THIS IS THE ACTIVE / CENTER VIDEO
      */

      v.muted = true;

  
      var p = v.play();

      if(p && p.then){
        p.then(function(){
     
        }).catch(function(err){
          console.error('[VIDEO] PLAY FAILED', {
            index: j,
            error: err,
            paused: v.paused,
            muted: v.muted,
            readyState: v.readyState
          });
        });
      }
    });
  }

  /* ---------------------------------------
     SOUND BUTTON
  --------------------------------------- */
    sec.addEventListener('click', function(e){

      var b = e.target.closest('.mnSnd');

      if(!b) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var cell = b.closest('.mnCell');
      var v = cell
        ? cell.querySelector('.mnCell__v')
        : null;

      if(!v) return;

      if(v.muted){

        // Mute other videos
        vids.forEach(function(other){

          if(other === v) return;

          other.muted = true;

          var otherCell = other.closest('.mnCell');
          var otherBtn = otherCell
            ? otherCell.querySelector('.mnSnd')
            : null;

          if(otherBtn){
            otherBtn.dataset.on = '0';
            otherBtn.setAttribute(
              'aria-label',
              'Play this film with sound'
            );
          }
        });

        // ONLY clicked video gets sound
        v.muted = false;

        b.dataset.on = '1';
        b.setAttribute(
          'aria-label',
          'Mute this film'
        );


      }else{

        // ONLY clicked video gets muted
        v.muted = true;

        b.dataset.on = '0';
        b.setAttribute(
          'aria-label',
          'Play this film with sound'
        );
      }

    }, true);

  /* ---------------------------------------
     DOT CLICK
  --------------------------------------- */

/* ---------------------------------------
   DOT CLICK
--------------------------------------- */

  dots.forEach(function(d, i){

    d.addEventListener('click', function(e){

      e.preventDefault();

      /* ACTIVE DOT */
      dots.forEach(function(item){
        item.removeAttribute('aria-current');
      });

      d.setAttribute('aria-current', 'true');

      /* FIND CARD */
      var c = cells[i];

      if(!c){
        console.error('[DOT CLICK] cell not found:', i);
        return;
      }

      /* CENTER CARD */
      var left =
        Math.max(
          0,
          c.offsetLeft -
          (
            tr.clientWidth -
            c.offsetWidth
          ) / 2
        );

      tr.scrollTo({
        left: left,
        behavior: (!LP.rm) ? 'smooth' : 'auto'
      });

    });

  });


  /* ---------------------------------------
     SCROLL
  --------------------------------------- */

  tr.addEventListener(
    'scroll',
    function(){

      if(ticking){
        return;
      }


      ticking = true;


      requestAnimationFrame(
        function(){

          markMid();

          ticking = false;

        }
      );

    },
    {
      passive: true
    }
  );


  /* ---------------------------------------
     INTERSECTION OBSERVER
  --------------------------------------- */

  var io =
    new IntersectionObserver(
      function(es){

        seen =
          es[0].isIntersecting;

        if(seen){

        

          play(
            lead < 0
              ? 0
              : lead
          );

        }else{

          vids.forEach(function(v, i){

            if(!v.paused){

            
              v.pause();

            }

          });

        }

      },
      {
        threshold: 0.2
      }
    );


  io.observe(sec);


  /* ---------------------------------------
     RESIZE
  --------------------------------------- */

  addEventListener(
    'resize',
    function(){


      measure();

      markMid();

    }
  );


  /* ---------------------------------------
     INITIAL
  --------------------------------------- */

  measure();

  markMid();


})();
})();
